import { useEffect, useState } from "react"
import { useSnackbar } from "notistack"
import moment from "moment/moment"
import { useSelector } from "react-redux"
import useUsers from "src/hooks/useUsers"
import useUsersByUnits from "src/hooks/useUsersByUnits"
import { sendNotification } from "src/config/sendNotification"
import * as FirestoreService from "./services/adminFirestore"

const useAdminNotificationFeed = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [transf, setTransf] = useState([])
  const [pagos, setPagos] = useState([])
  const [reparaciones, setReparaciones] = useState([])
  const [reservas, setReservas] = useState([])
  const [areas, setAreas] = useState([])
  const { usuarios } = useUsers()
  const { usersByUnit } = useUsersByUnits()
  const conjunto = useSelector(state => state.complex.complex)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    if (!conjunto.id) return
    Promise.all([
      FirestoreService.getTransfPendientes(conjunto.id),
      FirestoreService.getCuentasPagar(conjunto.id),
      FirestoreService.getReportes(conjunto.id),
      FirestoreService.getReservas(conjunto.id),
    ]).then(res => {
      setTransf(res[0])
      setPagos(res[1])
      setReparaciones(res[2])
      setReservas(res[3])
      const count = res.reduce((sum, cur) => sum + cur.length, 0)
      setTotal(count)
      FirestoreService.getAreasComunales(conjunto.id).then(querySnapshot => {
        const a = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }))
        setAreas(a)
      })
    })
  }, [conjunto.id])

  const findUserName = userId => {
    const user = usuarios.find(us => us.id === userId)
    return user ? `${user.Nombre} ${user.Apellido}` : "Desconocido"
  }

  const findArea = areaId => {
    const area = areas.find(a => a.id === areaId)
    return area ? `${area.Nombre}` : "Desconocido"
  }

  const handleAprobar = async (areaId, reserva) => {
    await FirestoreService.updateresv(conjunto.id, areaId, reserva.id, {
      Aprobada: true,
    })
      .then(() => {
        enqueueSnackbar(
          "Reserva aprobada, se envió la notificación al residente.",
          {
            variant: "success",
          }
        )
        setReservas(prevReservas =>
          prevReservas.filter(r => r.id !== reserva.id)
        )
      })
      .catch(() => {
        enqueueSnackbar("Hubo un error al aprobar la reserva.", {
          variant: "error",
        })
      })
    const tokens =
      usersByUnit.find(doc => doc.idUser === reserva?.Usuario)?.tokens || []
    sendNotification(
      `Reserva de ${findArea(areaId)}`,
      `¡Su reserva con fecha ${moment(reserva.Inicio.toDate()).format(
        "DD-MM-YYYY"
      )} ha sido aprobada!`,
      tokens
    )
  }

  return {
    title: "Notificaciones",
    total,
    conjunto,
    transf,
    pagos,
    reparaciones,
    reservas,
    setReservas,
    usersByUnit,
    findUserName,
    findArea,
    handleAprobar,
  }
}

export default useAdminNotificationFeed
